import { isElementNode, isTextNode } from 'anodum';
import getAdvancedSelection from '../../text-formatting/accessors/get-advanced-selection';
import findLastTextNode from './find-last-text-node';
import isBreakElement from '../verifiers/is-break-element';

const setCaretInTheEndOfNode = (node) => {
  let targetNode = node;
  let index = 0;

  if (!isTextNode(node) && !isBreakElement(node)) {
    targetNode = findLastTextNode(node, true);
  }

  if (isElementNode(targetNode)) {
    const parent = targetNode.parentNode;
    index = [...parent.childNodes].indexOf(targetNode);
    targetNode = parent;
  }

  if (isTextNode(targetNode)) {
    index = targetNode.length;
  }

  if (!targetNode) {
    targetNode = node;
  }

  const selection = getAdvancedSelection();
  const { ownerDocument: liveDocument } = node;
  const range = liveDocument.createRange();

  range.setStart(targetNode, index);
  range.setEnd(targetNode, index);
  selection.removeAllRanges();
  selection.addRange(range);
  selection.refresh();
};

export default setCaretInTheEndOfNode;
